import { Button, ButtonGroup, Card, Segment } from 'semantic-ui-react';
import useJobs from '../../hooks/useJobs';
import JobList from './JobList';
import JobStatistics from './JobStatistics';
import { useState } from 'react';
import JobLogs from './JobLogs';

const subModules = ['Logs', 'View Jobs'];
const JobContainer = () => {
  const [active, setActive] = useState(subModules[0].toLowerCase());
  const { jobs, loading } = useJobs();
  if (!loading || loading === 'loading') return <div>Loading...</div>;
  if (loading === 'failed') return <div>Failed to load jobs data.</div>;

  return (
    <div>
      <JobStatistics jobs={jobs} />
      <Card fluid>
        <ButtonGroup>
          <Button
            active={active === subModules[0].toLowerCase()}
            onClick={() => setActive(subModules[0].toLowerCase())}
          >
            Logs
          </Button>
          <Button
            active={active === subModules[1].toLowerCase()}
            onClick={() => setActive(subModules[1].toLowerCase())}
          >
            View Jobs
          </Button>
        </ButtonGroup>
        <Segment>
          {active === subModules[0].toLowerCase() && (
            <div>
              <JobLogs />
            </div>
          )}
          {active === subModules[1].toLowerCase() && <JobList jobs={jobs} />}
        </Segment>
      </Card>
    </div>
  );
};

export default JobContainer;
